"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    interactionTagSecondaryClassNames: function() {
        return interactionTagSecondaryClassNames;
    },
    useInteractionTagSecondaryStyles_unstable: function() {
        return useInteractionTagSecondaryStyles_unstable;
    }
});
const _react = require("@griffel/react");
const interactionTagSecondaryClassNames = {
    root: 'fui-InteractionTagSecondary'
};
const mediumIconSize = '20px';
const smallIconSize = '16px';
const extraSmallIconSize = '12px';
const useRootBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r7ezzwf", "rv64w1", [
    ".r7ezzwf{color:inherit;font-family:inherit;padding:0px;border-style:none;-webkit-appearance:button;-moz-appearance:button;-ms-appearance:button;appearance:button;text-align:unset;background-color:transparent;display:flex;height:100%;align-items:center;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);border-left-color:var(--colorNeutralStroke1);border-top-left-radius:var(--borderRadiusNone);border-bottom-left-radius:var(--borderRadiusNone);}",
    ".r7ezzwf[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}",
    ".rv64w1{color:inherit;font-family:inherit;padding:0px;border-style:none;-webkit-appearance:button;-moz-appearance:button;-ms-appearance:button;appearance:button;text-align:unset;background-color:transparent;display:flex;height:100%;align-items:center;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);border-right-color:var(--colorNeutralStroke1);border-top-right-radius:var(--borderRadiusNone);border-bottom-right-radius:var(--borderRadiusNone);}",
    ".rv64w1[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}"
]);
const useRootStyles = /*#__PURE__*/ (0, _react.__styles)({
    filled: {
        De3pzq: "f16xq7d1",
        sj55zd: "fkfq4zb",
        eoavqd: "f8491dx",
        Jwef8y: "f1h648pw",
        Bi91k9c: "f139oj5f",
        ecr2s2: "fwdzr64",
        lj723h: "f19au66r",
        Bqrx1nm: "fq7113v",
        kx9iu6: "fp3oj7s"
    },
    outline: {
        De3pzq: "fhovq9v",
        sj55zd: "fkfq4zb",
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1aperda",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ],
        eoavqd: "f8491dx",
        Jwef8y: "f1t94bn6",
        Bi91k9c: "f139oj5f",
        ecr2s2: "f1wfn5kd",
        lj723h: "f19au66r",
        Bqrx1nm: "fq7113v",
        kx9iu6: "fp3oj7s"
    },
    brand: {
        De3pzq: "f16xkysk",
        sj55zd: "f16muhyy",
        zhjwy3: [
            "f1sl6hi9",
            "f1c8dzaj"
        ],
        eoavqd: "f8491dx",
        Jwef8y: "f1yj72w4",
        Bi91k9c: "f3ymbdj",
        ecr2s2: "fy3sl2y",
        lj723h: "fryz5bw",
        Bqrx1nm: "fq7113v",
        kx9iu6: "fp3oj7s"
    },
    rounded: {
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ]
    },
    circular: {
        B7oj6ja: [
            "f1djnp8u",
            "f1s8kh49"
        ],
        Bbmb7ep: [
            "f8fbkgy",
            "f1nfllo7"
        ]
    },
    medium: {
        Be2twd7: "fe5j1ua",
        uwmqm3: [
            "f15vdbe4",
            "fwiuce9"
        ],
        z189sj: [
            "fwiuce9",
            "f15vdbe4"
        ]
    },
    small: {
        Be2twd7: "f4ybsrx",
        uwmqm3: [
            "f2lugmd",
            "f6zblan"
        ],
        z189sj: [
            "f6zblan",
            "f2lugmd"
        ]
    },
    "extra-small": {
        Be2twd7: "f1ugzwwg",
        uwmqm3: [
            "f15vdbe4",
            "fwiuce9"
        ],
        z189sj: [
            "fwiuce9",
            "f15vdbe4"
        ]
    }
}, {
    d: [
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}",
        ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}",
        ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}",
        ".f1aperda{border-bottom-color:var(--colorNeutralStroke1);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        ".f16muhyy{color:var(--colorBrandForeground1);}",
        ".f1sl6hi9{border-left-color:var(--colorBrandStroke2);}",
        ".f1c8dzaj{border-right-color:var(--colorBrandStroke2);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1djnp8u{border-top-right-radius:var(--borderRadiusCircular);}",
        ".f1s8kh49{border-top-left-radius:var(--borderRadiusCircular);}",
        ".f8fbkgy{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".f1nfllo7{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".fe5j1ua{font-size:20px;}",
        ".f15vdbe4{padding-left:5px;}",
        ".fwiuce9{padding-right:5px;}",
        ".f4ybsrx{font-size:16px;}",
        ".f2lugmd{padding-left:3px;}",
        ".f6zblan{padding-right:3px;}",
        ".f1ugzwwg{font-size:12px;}"
    ],
    h: [
        ".f8491dx:hover{cursor:pointer;}",
        ".f1h648pw:hover{background-color:var(--colorNeutralBackground3Hover);}",
        ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".f1yj72w4:hover{background-color:var(--colorBrandBackground2Hover);}",
        ".f3ymbdj:hover{color:var(--colorCompoundBrandForeground1Hover);}"
    ],
    a: [
        ".fwdzr64:active{background-color:var(--colorNeutralBackground3Pressed);}",
        ".f19au66r:active{color:var(--colorNeutralForeground2BrandPressed);}",
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".fy3sl2y:active{background-color:var(--colorBrandBackground2Pressed);}",
        ".fryz5bw:active{color:var(--colorCompoundBrandForeground1Pressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fq7113v:hover{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fp3oj7s:active{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useRootDisabledStyles = /*#__PURE__*/ (0, _react.__styles)({
    filled: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1bg9a2p",
        sj55zd: "f1s2aq7o",
        g2u3we: "fgig46g",
        h3c5rm: [
            "f1mxt3zg",
            "fziff3p"
        ],
        B9xav0g: "f250w3l",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ]
    },
    outline: {
        Bceei9c: "fdrzuqr",
        De3pzq: "fhovq9v",
        sj55zd: "f1s2aq7o",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ]
    },
    brand: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1bg9a2p",
        sj55zd: "f1s2aq7o",
        g2u3we: "fgig46g",
        h3c5rm: [
            "f1mxt3zg",
            "fziff3p"
        ],
        B9xav0g: "f250w3l",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ]
    }
}, {
    d: [
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fgig46g{border-top-color:var(--colorTransparentStrokeDisabled);}",
        ".f1mxt3zg{border-right-color:var(--colorTransparentStrokeDisabled);}",
        ".fziff3p{border-left-color:var(--colorTransparentStrokeDisabled);}",
        ".f250w3l{border-bottom-color:var(--colorTransparentStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}"
    ]
});
const useInteractionTagSecondaryStyles_unstable = (state)=>{
    const rootBaseClassName = useRootBaseClassName();
    const rootStyles = useRootStyles();
    const rootDisabledStyles = useRootDisabledStyles();
    const { shape, size, appearance } = state;
    state.root.className = (0, _react.mergeClasses)(interactionTagSecondaryClassNames.root, rootBaseClassName, state.disabled ? rootDisabledStyles[appearance] : rootStyles[appearance], rootStyles[shape], rootStyles[size], state.root.className);
    return state;
}; //# sourceMappingURL=useInteractionTagSecondaryStyles.styles.js.map
